import { axios } from '@/utils/request'

/**
 * 查询药房管理1
 *
 * @author liwei
 * @date 2022-04-15 08:15:28
 */
export function baPharmacyPage (parameter) {
  return axios({
    url: '/baPharmacy/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 药房管理1列表
 *
 * @author liwei
 * @date 2022-04-15 08:15:28
 */
export function baPharmacyList (parameter) {
  return axios({
    url: '/baPharmacy/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加药房管理1
 *
 * @author liwei
 * @date 2022-04-15 08:15:28
 */
export function baPharmacyAdd (parameter) {
  return axios({
    url: '/baPharmacy/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑药房管理1
 *
 * @author liwei
 * @date 2022-04-15 08:15:28
 */
export function baPharmacyEdit (parameter) {
  return axios({
    url: '/baPharmacy/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除药房管理1
 *
 * @author liwei
 * @date 2022-04-15 08:15:28
 */
export function baPharmacyDelete (parameter) {
  return axios({
    url: '/baPharmacy/delete',
    method: 'get',
    params: parameter
  })
}

/**
 * 导出药房管理1
 *
 * @author liwei
 * @date 2022-04-15 08:15:28
 */
export function baPharmacyExport (parameter) {
  return axios({
    url: '/baPharmacy/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}



/**
 * 查询地区
 *
 * @author liwei
 * @date 2022-04-15 08:15:28
 */
export function baPharmacyArea (parameter) {
  return axios({
    url: '/baPharmacy/selectArea',
    method: 'get',
    params: parameter
  })
}
